import { TextChirpContentBlockTypename, ThinkingChirpContentBlockTypename, RedactedThinkingChirpContentBlockTypename, DisplayOnlyChirpContentBlockTypename, ContextChirpContentBlockTypename, ImageChirpContentBlockTypename, PdfChirpContentBlockTypename, FileChirpContentBlockTypename, ToolUseChirpContentBlockTypename, ToolResultChirpContentBlockTypename, ImageToolResultChirpContentBlockTypename, PendingToolResultChirpContentBlockTypename, ServerToolUseChirpContentBlockTypename } from '../../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineStreamingService';
import { parseDisplayOnlyBlock } from './displayOnlyUtils';
export function normalizeBlock(block, strippedText) {
  switch (block.__typename) {
    case TextChirpContentBlockTypename:
      {
        const rawText = strippedText !== null && strippedText !== void 0 ? strippedText : block.text;
        return {
          type: 'TEXT',
          text: rawText
        };
      }
    case ThinkingChirpContentBlockTypename:
      {
        const thinking = block;
        if (thinking.thinkingSections.length === 0) return null;
        const text = thinking.thinkingSections.map(section => section.content).join('\n\n');
        return {
          type: 'THINKING',
          text
        };
      }
    case RedactedThinkingChirpContentBlockTypename:
      return {
        type: 'REDACTED_THINKING',
        data: block.data
      };
    case DisplayOnlyChirpContentBlockTypename:
      return parseDisplayOnlyBlock(block);
    case ContextChirpContentBlockTypename:
      return null;
    case ImageChirpContentBlockTypename:
      return {
        type: 'IMAGE',
        base64Data: block.base64Data,
        mimeType: block.mimeType
      };
    case PdfChirpContentBlockTypename:
      return Object.assign({
        type: 'PDF',
        base64Data: block.base64Data,
        fileType: 'PDF'
      }, block.filename !== undefined ? {
        filename: block.filename
      } : {});
    case FileChirpContentBlockTypename:
      return Object.assign({
        type: 'FILE',
        base64Data: block.base64Data,
        fileType: String(block.fileType)
      }, block.filename !== undefined ? {
        filename: block.filename
      } : {});
    case ToolUseChirpContentBlockTypename:
    case ServerToolUseChirpContentBlockTypename:
    case ToolResultChirpContentBlockTypename:
    case ImageToolResultChirpContentBlockTypename:
    case PendingToolResultChirpContentBlockTypename:
      return null;
    default:
      return null;
  }
}